module.exports = __webpack_public_path__ + "img/IMG_1454_L_BlackMatted.d8ba869a.jpg";